import { useContext } from 'react';
import { TextButton } from '@zillow/constellation-10';
import { LoadingMapContext } from '../../../../providers/LoadingMapContext/context';
import type { MouseEvent } from 'react';

type Props = {
  listingPath: string;
  onClick: (event: MouseEvent<HTMLAnchorElement>) => void;
};

export function ListingModuleDetailsCta({ listingPath, onClick }: Props) {
  const {
    loadingByComponent: { ListingModule: isListingModuleLoading },
  } = useContext(LoadingMapContext);
  return (
    !isListingModuleLoading && (
      <TextButton tone="brand" asChild>
        <a href={listingPath} target="_self" onClick={onClick}>
          Details
        </a>
      </TextButton>
    )
  );
}
